import progress from 'nprogress'
import { db } from '@/core/shared'

export const mutations = {
    setPrograms: 'admin/setPrograms',
    setSpots: 'admin/setSpots'
}
export const actions = {
    fetchPrograms: 'admin/fetchPrograms',
    fetchSpots: 'admin/fetchSpots'
}

export const store = {
    state: {
        programs: [],
        spots: []
    },
    mutations: {
        [mutations.setPrograms]: (state, payload) => {
            state.programs = payload
        },
        [mutations.setSpots]: (state, payload) => {
            state.spots = payload
        },
    },
    actions: {
        [actions.fetchPrograms]: async (context) => {
            progress.start()
            const items = []
            const programs = await db.collection('programs').get()
            programs.forEach(x => {
                const data = x.data()
                items.push({
                    id: x.id,
                    ...data
                })
            })
            progress.done()
            context.commit(mutations.setPrograms, items)
        },
        [actions.fetchSpots]: async (context) => {
            progress.start()
            const items = []
            const spots = await db.collection('spots').get()
            spots.forEach(x => {
                const data = x.data()
                items.push({
                    id: x.id,
                    ...data
                })
            })
            progress.done()
            context.commit(mutations.setSpots, items)
        }
    }
}